import { render, staticRenderFns } from "./studentsList.vue?vue&type=template&id=26f0de82&scoped=true&"
import script from "./studentsList.vue?vue&type=script&lang=js&"
export * from "./studentsList.vue?vue&type=script&lang=js&"
import style0 from "./studentsList.vue?vue&type=style&index=0&id=26f0de82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f0de82",
  null
  
)

export default component.exports